import {Avatar} from 'antd'
import classNames from 'classnames'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {IoCheckmarkCircleOutline, IoCloseCircleOutline, IoRefreshCircle, IoTimeOutline,} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {SearchGroupIcon} from "../../../../components/AppIcon";
import {getType} from "../../../../apis/model/base";
import {OrgType} from "../../Organization/components/OrgType";

export const fromHostStatus = (value) => {
    switch (value) {
        case -1:
            return {
                label: 'pending',
                className: 'border border-blue-500 text-blue-500',
                icon: <IoTimeOutline size={12}/>,
            }
        case 1:
            return {
                label: 'approved',
                className: 'border border-green-500 text-green-500',
                icon: <IoCheckmarkCircleOutline size={12}/>,
            }
        case -8:
            return {
                label: 'has left',
                className: 'bg-orange-600 text-white',
                icon: <IoRefreshCircle size={12}/>,
            }
        case -9:
            return {
                label: 'rejected',
                className: 'border border-red-500 text-red-500',
                icon: <IoCloseCircleOutline size={12}/>,
            }
        default:
            return {}
    }
}

const HostContent = ({item, status, subItem, actions = null}) => {
    const t = useTranslate()
    const {label, className, icon} = fromHostStatus(status)
    const verified = _.get(item, 'certified')
    const type = getType(item)

    return (
        <div className="flex flex-col relative">
            <div className="mb-2 pb-2 border-b border-color-50 flex items-center gap-2">
                <Avatar
                    size={40}
                    className="flex flex-center background-200"
                    shape={type === "organization" ? "square" : "circle"}
                    src={getAvatar(item)}
                    icon={<SearchGroupIcon size={20} type={type} className="text-color-500"/>}
                />
                <div className="flex flex-col flex-1">
                    <Link
                        to={getLinkToDetail(item)}
                        className="flex-1 font-bold text-color-000 max-lines-1 no-underline leading-snug">
                        {getTitle(item)}
                    </Link>
                    {
                        type === "organization"
                            ? (
                                <OrgType item={item} className="font-medium text-xs text-blue-500 italic leading-snug"/>
                            ) : (
                                <div className="italic text-xs font-medium">{t("user")}</div>
                            )
                    }
                </div>
            </div>
            <div className="flex justify-end">
                <div
                    style={{padding: '4px 12px', right: 8, bottom: 8}}
                    className={classNames(
                        'w-fit flex flex-center gap-1 truncate italic rounded-full',
                        className
                    )}>
                    {icon}
                    {label && (<span className="font-medium text-xs leading-tight">{t(label)}</span>)}
                </div>
            </div>
        </div>
    )
}

export default HostContent
